import React from 'react';
interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  helperText?: string;
}
export function Input({
  label,
  error,
  helperText,
  className = '',
  id,
  ...props
}: InputProps) {
  const inputId = id || props.name || Math.random().toString(36).substr(2, 9);
  return <div className="w-full" data-id="element-218">
      {label && <label htmlFor={inputId} className="block text-sm font-medium text-gray-700 mb-1" data-id="element-219">
          {label}
        </label>}
      <input id={inputId} className={`
          w-full px-4 py-2 rounded-lg border bg-white transition-colors duration-200
          focus:outline-none focus:ring-2 focus:ring-[#1e3a5f] focus:border-transparent
          disabled:bg-gray-100 disabled:text-gray-500
          ${error ? 'border-red-500 focus:ring-red-500' : 'border-gray-300'}
          ${className}
        `} {...props} data-id="element-220" />
      {error && <p className="mt-1 text-sm text-red-600" data-id="element-221">{error}</p>}
      {helperText && !error && <p className="mt-1 text-sm text-gray-500" data-id="element-222">{helperText}</p>}
    </div>;
}